/**
* @prop --uic-header-menu-indicator-color: color of the indicator
* @prop --uic-header-menu-indicator-transition: duration and speed of the transition
*/
uic-header-menu-indicator {
  background-color: var(--uic-header-menu-indicator-color);
  display: block;
  position: absolute;
  transition: transform var(--uic-header-menu-indicator-transition), width var(--uic-header-menu-indicator-transition);
}

.uic-header-menu-indicator--horizontal {
  bottom: 0;
  height: 4px;
  left: 0;
  top: auto;
  width: 0;
}

.uic-header-menu-indicator--vertical {
  bottom: auto;
  height: 0;
  left: 0;
  top: 0;
  width: 4px;
}
